<h1 mat-dialog-title>
  <mat-icon *ngIf="type == 'success'" class="icon-success">check_circle_outline</mat-icon>
</h1>
<div class="confirm-dialog-message" mat-dialog-content>
  {{ confirmMessage }}
</div>
<div class="confirm-dialog-actions" mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close(true)" color="primary">
    Chiudi
  </button>
  <button mat-raised-button *ngIf="type != 'success' && type != 'error' && type != 'info'" (click)="dialogRef.close(false)">
    Annulla
  </button>
</div>
